/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import Keyboard from '../components/keyboard/Keyboard';
import {setField} from '../../common/lib/redux-fields/actions';
import {apiLogin} from '../../common/login/actions';
import {removeErrors, setOfflineError} from '../../common/app/actions';
import {setFocusId} from '../../common/components/keyboard/actions';
import {changeOrganization, findGetParameter, getUserAgent, isEnv} from '../../common/lib/util';
import QuitButton from '../components/buttons/QuitButton';
import LanguageSwitcher from '../components/intl/LanguageSwitcher';
import {changeDeviceSettings} from "../../common/device/actions";

class Login extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        setOfflineError: React.PropTypes.func,
        setField: React.PropTypes.func,
        setFocusId: React.PropTypes.func,
        removeErrors: React.PropTypes.func,
        apiLogin: React.PropTypes.func,
        fields: React.PropTypes.object,
        error: React.PropTypes.object,
        deviceId: React.PropTypes.number,
        organizationName: React.PropTypes.string,
        formDisabled: React.PropTypes.bool,
        changeDeviceSettings: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.onChangeForm = this.onChangeForm.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onQuit = this.onQuit.bind(this);
        this.redirectToDomainChoosing = this.redirectToDomainChoosing.bind(this);
    }

    onChangeForm({target: {name, value}}) {
        const {setField} = this.props;
        setField(name, value);
    }

    onFormSubmit(e) {
        e.preventDefault();
        const {apiLogin, fields, msg, setOfflineError, deviceId} = this.props;

        const email = fields.getIn('email');
        const password = fields.getIn('password');
        const userAgent = getUserAgent();

        apiLogin({email, password, deviceId, userAgent}).payload.promise
            .then(() => {

            })
            .catch((res) => {
                if (!res.status) {
                    setOfflineError(msg.domain.serverUnavailable);
                }
            });
    }

    onQuit(e) {
        if (isEnv(['android_app', 'electron'])) {
            if (isEnv(['android_app', 'electron'])) {
                if (typeof window.parent.Ocellot !== 'undefined') {
                    window.parent.Ocellot.quit();
                } else {
                    window.parent.ocellotQuit();
                }
            }
        }
    }

    componentDidMount() {
        const {changeDeviceSettings} = this.props;
        const activeDomain = localStorage.getItem('domain');
        if (!activeDomain) { // If there is no domain in local storage (and none of the above passed), redirect to choose-domain
            this.redirectToDomainChoosing();
        }
        if (!!localStorage.getItem('domain')) {
            changeDeviceSettings('organizationDomain', activeDomain);
        }
    }

    componentWillMount() {
        const {setField, removeErrors} = this.props;
        removeErrors();
        setField('email', '');
        setField('password', '');
    }

    componentWillUnmount() {
        const {removeErrors} = this.props;
        removeErrors();
    }

    redirectToDomainChoosing() {
        setTimeout(function(){
            location.href = '/choose-domain';
        }, 5);
    }

    render() {
        const {fields, formDisabled, error, setFocusId, organizationName, msg} = this.props;

        return (
            <div id="login-page" className="pageLogin keyboardPanel">
                <h1 className="pageLogin-logo view-big">
                    {msg.global.appName} {!!organizationName && `- ${organizationName}`}
                </h1>
                <div className="pageLogin-link pageLogin-changeOrg">
                    <span onClick={() => changeOrganization()}>{msg.login.changeOrganization}</span>
                </div>
                {isEnv(['android_app', 'electron']) &&
                    <div className="pageLogin-quit">
                        <button className="boxBtn color-red" onClick={this.onQuit}>
                            <QuitButton/>
                        </button>
                    </div>
                }

                <LanguageSwitcher/>
                <a className="migrationTroubleshooter-link" href="/migration-troubleshooter">{msg.domain.migrationTroubleshoot}</a>

                <div className="keyboardPanel-panel">
                    <form className="form"
                          autoComplete="off"
                          id="formWithKeyboard"
                          onChange={e => this.onChangeForm(e)}
                          onSubmit={e => this.onFormSubmit(e)}>
                        <fieldset disabled={formDisabled}>
                            <div className="form-row">
                                <label htmlFor="login" className="form-label">{msg.login.login}</label>
                                <input autoFocus
                                       autoCapitalize="off"
                                       autoCorrect="off"
                                       autoComplete="off"
                                       spellCheck="off"
                                       onFocus={() => setFocusId('email')}
                                       type="email"
                                       className="form-input"
                                       name="email"
                                       tabIndex="1"
                                       value={fields.getIn('email')}
                                       id="email"/>
                            </div>
                            <div className="form-row">
                                <label htmlFor="password" className="form-label">{msg.login.password}</label>
                                <input type="password"
                                       autoComplete="off"
                                       onFocus={() => setFocusId('password')}
                                       name="password"
                                       className="form-input"
                                       value={fields.getIn('password')}
                                       tabIndex="2"
                                       id="password"/>
                            </div>

                            {!!error &&
                            <div className="form-errors">
                                <div className="errors">
                                    <ul>
                                        {error.map((err, i) =>
                                            <li key={`error-key-${i}`}>{err}</li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            }

                            <div className="form-btns">
                                <button type="submit" className="btn btn-green btn-block">{msg.login.loginBtn}</button>
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div className="keyboardPanel-keyboard">
                    {isEnv(['electron', 'web_desktop']) &&
                    <Keyboard/>
                    }
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    fields: state.fields,
    formDisabled: state.login.get('formDisabled'),
    deviceId: state.device.get('id'),
    organizationName: state.device.get('organizationName'),
    error: state.app.get('error')
}), {setField, apiLogin, changeDeviceSettings, removeErrors, setFocusId, setOfflineError})(Login);



// WEBPACK FOOTER //
// ./src/browser/login/Login.js